export default {
    apiUrl:"https://api.esox.windgis.io/api/",
    basemap:"mapbox://styles/lautec/ck949aof41kc41itbk257vk78",
    mapboxApiKey:"pk.eyJ1IjoibGF1dGVjIiwiYSI6ImNrNzRpNjFxaTBpc2IzZnBkNHU3MGJoMmoifQ.yNFawhQiPQGVujuEwb-TIg"
}